<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Form]="Form" [Parent]="this" (click)="Save()"></app-form-save-button>
    </app-pageheader>
    <app-validationsummary [Form]="Form"></app-validationsummary>
    <div>
      <div class="column is-9">
        <article class="panel">
          <p class="panel-heading">
            Permit Type Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Name" tippy="The name that users will see when booking hotel reservations">
              <p class="control mb-2">
                <input formControlName="Name" class="input" type="text" placeholder="Guest Group Name" />
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </p>
            </app-field>
            <app-field Label="Unique Code" tippy="Optional. If set, must be unique among currently-active hotel reservation permit types. Guests can enter this code on the public hotel parking registration page to select this permit type instead of the organization's default.">
              <p class="control mb-2">
                <input formControlName="UniqueCode" class="input" type="text" maxlength="128" (input)="OnUniqueCodeInput($event)" />
                <app-validator [For]="this.Form.get('UniqueCode')"></app-validator>
              </p>
            </app-field>
            <app-field Label="Active Period" [HasAddons]="true" tippy="Defines the period hotel reservation permits of this type can be used.">
              <div class="control is-expanded mb-2">
                <input formControlName="ActiveStartDateLocal" class="input" type="date" required>
                <app-validator [For]="this.Form.get('ActiveStartDateLocal')"></app-validator>
              </div>
              <div class="control">
                <button class="button is-static"> to </button>
              </div>
              <div class="control is-expanded mb-2">
                <input formControlName="ActiveEndDateLocal" class="input" type="date" required>
                <app-validator [For]="this.Form.get('ActiveEndDateLocal')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Maximum Active Permits" tippy="The maximum number of active hotel reservations of this type, or unlimited if no limit is specified.">
              <p class="control is-expanded mb-2">
                <input formControlName="MaxActivePermits" class="input" type="number" min="0" max="1000000" placeholder="No Limit" />
                <app-validator [For]="this.Form.get('MaxActivePermits')"></app-validator>
              </p>
            </app-field>
            <app-field Label="Requires Approval">
              <label class="checkbox mb-2">
                <input formControlName="RequiresApproval" type="checkbox" />
                  Requires staff approval before activation
                </label>
              <app-validator [For]="this.Form.get('RequiresApproval')"></app-validator>
            </app-field>
            <app-field Label="Cutoff Time" tippy="If set, permits of this type will expire at this exact time on the checkout date, instead of at midnight.">
              <p class="control mb-2">
                <input formControlName="CutoffTimeLocal" class="input time" type="time" />
                <app-validator [For]="this.Form.get('CutoffTimeLocal')"></app-validator>
              </p>
            </app-field>
            @if (this.Form.get('RequireRegisteredVehicles')?.value) {
              <app-field Label="Max Vehicles" [HasAddons]="true" tippy="The maximum number of vehicles that can be added to a reservation permit.">
                <p class="control is-expanded mb-2">
                  <input formControlName="MaxVehicles" class="input" type="number" min="0" max="1000000" placeholder="No Limit" />
                  <app-validator [For]="this.Form.get('MaxVehicles')"></app-validator>
                </p>
                <div class="control">
                  <button class="button is-static"> vehicles max, with a cooldown period of </button>
                </div>
                <p class="control is-expanded mb-2">
                  <input formControlName="VehicleModificationTimeout" class="input" type="number" min="0" max="10000" placeholder="No Limit" />
                  <app-validator [For]="this.Form.get('VehicleModificationTimeout')"></app-validator>
                </p>
                <p class="control">
                  <button class="button is-static"> hrs </button>
                </p>
              </app-field>
            }
          </div>
        </article>
      </div>
      <div class="column is-9">
        <article class="panel">
          <div class="panel-heading">Pricing</div>
          <div class="panel-block" style="display:block;">
            <app-field Label="Prices" formArrayName="Prices" tippy="The price of the permit. For One-Off Payments, this is the total payable." [HasAddons]="true">
              <div class="control">
                <span>
                  @for (price of FormArray(this.Form, 'Prices').controls; track price; let i = $index) {
                    <div>
                      <div [formGroupName]="i">
                        <div style="display: flex;">
                          <div class="control is-expanded has-addons mb-2">
                            <app-currency-input formControlName="Price">
                            </app-currency-input>
                          </div>
                          <div class="control is-expanded has-addons mb-2">
                            <div class="select">
                              <select class="input" formControlName="PaymentPeriod">
                                <option value="0">Once</option>
                                <option value="1">Daily</option>
                                <option value="2">Weekly</option>
                                <option value="3">Monthly</option>
                                <option value="4">Yearly</option>
                              </select>
                            </div>
                          </div>
                          <div class="control is-expanded has-addons">
                            <button class="button is-static"> from </button>
                          </div>
                          <div class="control is-expanded has-addons mb-2">
                            <input formControlName="EffectiveStartDateLocal" class="input" type="date">
                          </div>
                          <div class="control has-addons">
                            <button class="button is-light ng-star-inserted" [disabled]="price.get('NotificationSent')?.value" (click)="RemovePrice(i)"><i class="fa fa-trash"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </span>
                <add-button Class="is-small" (AddObject)="AddPrice()"></add-button>
              </div>
            </app-field>
          </div>
        </article>
      </div>
    </div>
  </div>
}


